import moment from "moment"
import i18n from "../utilities/i18n"
import { WEEK, MONTH, YEAR } from "./application"
import { Date_Format } from "./years"

export function transactionReportColumnDefs() {
  return [
    { name: "fleet_name", label: i18n.t("reports:fleetNameLabel") },
    { name: "shop_order", label: i18n.t("reports:shopOrderLabel") },
    { name: "order_date", label: i18n.t("reports:orderDateLabel") },
    { name: "vehicle", label: i18n.t("reports:vehicleNameLabel") },
    { name: "vin", label: i18n.t("reports:vehicleVinLabel") },
    { name: "other_id", label: i18n.t("reports:otherIdLabel") },
    { name: "invoice_number", label: i18n.t("reports:invoiceNumberLabel") },
    {
      name: "services",
      label: i18n.t("reports:serviceLabel"),
      options: { customBodyRender: (value) => value }
    },
    {
      name: "amount",
      label: i18n.t("reports:totalLabel"),
      options: { customBodyRender: (value) => `$${Number(value).toFixed(2)}` }
    }
  ]
}

export const FILTER_OPTIONS = [
  {
    value: WEEK,
    label: i18n.t("reports:lastWeekLabel")
  },
  {
    value: MONTH,
    label: i18n.t("reports:lastMonthLabel")
  },
  {
    value: YEAR,
    label: i18n.t("reports:lastYearLabel")
  }
]

export function convertDateToString(filters) {
  return {
    ...filters,
    appointment_datetime_to:
      filters.appointment_datetime_to && filters.appointment_datetime_to instanceof moment
        ? filters.appointment_datetime_to.format(Date_Format.YYYY_MM_DD)
        : filters.appointment_datetime_to,
    appointment_datetime_from:
      filters.appointment_datetime_from && filters.appointment_datetime_from instanceof moment
        ? filters.appointment_datetime_from.format(Date_Format.YYYY_MM_DD)
        : filters.appointment_datetime_from
  }
}
